import { useState, FormEvent } from "react";
import styles from "./FooterSection.module.css";
import logo from "../../assets/img/logo.webp";

/* ────────────────────────────────────────────
   FOOTER SECTION  —  iGiTREE
   ──────────────────────────────────────────── */

/* ── Social icon SVGs ── */
const IconFacebook = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);
const IconTwitter = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
  </svg>
);
const IconInstagram = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);
const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const IconArrow = () => (
  <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
  </svg>
);

const IconMapPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);
const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l1.09-.92a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

/* ── Logo ── */
const Logo = () => (
  <div className={styles.logoWrap}>
    <img src={logo} alt="iGiTREE Logo" className={styles.logoIcon} />
  </div>
);

/* ── Data ── */
const quickLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Our Services", href: "/#services" },
  { label: "DNA Testing", href: "/dna-testing-and-matching" },
  { label: "Family Tree", href: "/family-tree-build" },
  { label: "iGiTREE Connect", href: "/igitree-connect" },
  { label: "Pricing", href: "/upgrade" },
  { label: "Contact Us", href: "/contact" },
];

const legalLinks = [
  { label: "Privacy Policy", href: "/privacy_policy" },
  { label: "Terms of Service", href: "/privacy_policy" },
  { label: "Cookie Policy", href: "/privacy_policy" },
  { label: "GDPR Compliance", href: "/privacy_policy" },
];

const socials = [
  { icon: <IconFacebook />, label: "Facebook", href: "https://web.facebook.com/profile.php?id=100068651515635" },
  { icon: <IconTwitter />, label: "Twitter", href: "https://x.com/igiTree" },
  { icon: <IconInstagram />, label: "Instagram", href: "https://www.instagram.com/igi_tree/" },
  { icon: <IconLinkedIn />, label: "LinkedIn", href: "https://www.linkedin.com/in/deexonmuhizi/" },
];

/* ════════════════════════════════════════════
   COMPONENT
   ════════════════════════════════════════════ */
export default function FooterSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");

  const handleSubscribe = (e: FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      setStatus("error");
      return;
    }
    setStatus("success");
    setEmail("");
    setTimeout(() => setStatus("idle"), 4000);
  };

  return (
    <footer className={styles.footer} id="newsletter">

      {/* ── Bezier Wave + Newsletter ── */}
      <div className={styles.waveSection}>
        {/* SVG waves — modelled on the screenshot's bezier curves */}
        <svg
          className={styles.waveSvg}
          viewBox="0 0 1440 320"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          {/* Decorative arc 1 — purple */}
          <path
            d="M 200 260 Q 450 80 700 240 Q 950 400 1200 200"
            fill="none"
            stroke="rgba(167,139,250,0.55)"
            strokeWidth="2.5"
          />
          {/* Decorative arc 2 — cyan */}
          <path
            d="M 500 200 Q 750 20 1000 180 Q 1200 320 1440 100"
            fill="none"
            stroke="rgba(34,211,238,0.5)"
            strokeWidth="2"
          />
          {/* Main blue wave fill */}
          <path
            d="M0 160
               C 120 60, 280 20, 440 100
               C 560 160, 680 220, 820 180
               C 960 140, 1080 60, 1220 100
               C 1320 130, 1400 160, 1440 150
               L 1440 320 L 0 320 Z"
            fill="url(#waveGrad1)"
          />
          {/* Secondary lighter wave for depth */}
          <path
            d="M0 200
               C 180 110, 340 80, 500 150
               C 640 210, 760 260, 920 220
               C 1060 185, 1200 120, 1380 170
               L 1440 180 L 1440 320 L 0 320 Z"
            fill="url(#waveGrad2)"
            opacity="0.6"
          />
          <defs>
            <linearGradient id="waveGrad1" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#3b6ff5" />
              <stop offset="60%" stopColor="#2f8cf0" />
              <stop offset="100%" stopColor="#06b6d4" />
            </linearGradient>
            <linearGradient id="waveGrad2" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#2563eb" stopOpacity="0.7" />
              <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.5" />
            </linearGradient>
          </defs>
        </svg>

        {/* Newsletter content sits on top of the wave */}
        <div className={styles.newsletterContent}>
          <h2 className={styles.newsletterTitle}>
            Join Our Mailing List To Receive The News &amp;{" "}
            <span className={styles.newsletterTitleAccent}>Latest Trends</span>
          </h2>
          <p className={styles.newsletterSub}>
            Be the first to know about new features, family reunion success stories, and iGiTREE updates.
          </p>

          <form className={styles.subscribeForm} onSubmit={handleSubscribe} noValidate>
            <div className={styles.inputWrap}>
              <IconMail />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address..."
                className={styles.emailInput}
                aria-label="Email address"
              />
            </div>
            <button type="submit" className={styles.subscribeBtn}>
              Subscribe Now <IconArrow />
            </button>
          </form>

          {status === "success" && (
            <p className={styles.feedbackSuccess}>🎉 You're subscribed! Welcome to the iGiTREE family.</p>
          )}
          {status === "error" && (
            <p className={styles.feedbackError}>Please enter a valid email address.</p>
          )}
        </div>
      </div>

      {/* ── Main footer body ── */}
      <div className={styles.footerBody}>
        <div className={styles.footerGrid}>

          {/* Col 1 — Brand */}
          <div className={styles.brandCol}>
            <Logo />
            <p className={styles.brandDesc}>
              iGiTREE empowers people around the world to discover their heritage,
              build family trees, and reconnect with loved ones through AI and DNA science.
            </p>
            <div className={styles.socials}>
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className={styles.socialLink}
                  aria-label={s.label}
                  target="_blank"
                  rel="noreferrer"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 — Quick links */}
          <div className={styles.linksCol}>
            <h4 className={styles.colHeading}>Quick Links</h4>
            <ul className={styles.linkList}>
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className={styles.linkItem}>
                    <span className={styles.linkArrow}>›</span> {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Legal */}
          <div className={styles.linksCol}>
            <h4 className={styles.colHeading}>Legal</h4>
            <ul className={styles.linkList}>
              {legalLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className={styles.linkItem}>
                    <span className={styles.linkArrow}>›</span> {l.label}
                  </a>
                </li>
              ))}
            </ul>
            {/* <h4 className={`${styles.colHeading} ${styles.colHeadingSpaced}`}>App Downloads</h4>
            <div className={styles.appBadges}>
              <a href="#" className={styles.appBadge}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                App Store
              </a>
              <a href="#" className={styles.appBadge}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M3.18 23.76c.31.17.67.19 1 .06l12.35-6.17-2.89-2.89-10.46 9zM.1 1.5C.04 1.74 0 2 0 2.27v19.46c0 .27.04.53.1.77l10.58-10.59L.1 1.5zM14.83 12l2.51 2.51 2.93-1.46c.84-.42.84-1.1 0-1.52l-2.93-1.46L14.83 12zM4.17.17L14.83 11l2.89-2.89L5.17.11C4.83-.04 4.47-.02 4.17.17z"/>
                </svg>
                Google Play
              </a>
            </div> */}
          </div>

          {/* Col 4 — Contact */}
          <div className={styles.contactCol}>
            <h4 className={styles.colHeading}>Get In Touch</h4>
            <ul className={styles.contactList}>
              <li className={styles.contactItem}>
                <IconMapPin />
                <span>1 KN 78 St, Kigali</span>
              </li>
              <li className={styles.contactItem}>
                <IconMail />
                <a href="muhizidee@gmail.com" className={styles.contactLink}>muhizidee@gmail.com</a>
              </li>
              <li className={styles.contactItem}>
                <IconPhone />
                <a href="tel:+250787961983" className={styles.contactLink}>+250 787 961 983</a>
              </li>
            </ul>

            {/* Trust badges */}
            {/* <div className={styles.trustBadges}>
              <div className={styles.trustBadge}>🔒 SSL Secured</div>
              <div className={styles.trustBadge}>🛡️ GDPR Ready</div>
              <div className={styles.trustBadge}>🌍 Global Reach</div>
            </div> */}
          </div>

        </div>

        {/* Bottom bar */}
        <div className={styles.bottomBar}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} iGiTREE. All rights reserved. Built with ❤️ to reconnect families worldwide.
          </p>
          <div className={styles.bottomLinks}>
            <a href="/privacy_policy" className={styles.bottomLink}>Privacy</a>
            <span className={styles.bottomDivider}>·</span>
            <a href="/privacy_policy" className={styles.bottomLink}>Terms</a>
            <span className={styles.bottomDivider}>·</span>
            <a href="/" className={styles.bottomLink}>Sitemap</a>
          </div>
        </div>
      </div>

    </footer>
  );
}